import e1f9d8 from '@/assets/emoji/1f9d8.svg';
import e1fac1 from '@/assets/emoji/1fac1.svg';
import e1f9ed from '@/assets/emoji/1f9ed.svg';
import e1f9e0 from '@/assets/emoji/1f9e0.svg';
import e1f389 from '@/assets/emoji/1f389.svg';
import e1f331 from '@/assets/emoji/1f331.svg';
import e1f34e from '@/assets/emoji/1f34e.svg';
import e1f319 from '@/assets/emoji/1f319.svg';

// Единый набор красивых эмодзи (Twemoji, самохост — без CDN, работает в РФ).
// Заменяет системные «мессенджерные» эмодзи на одинаковые на всех устройствах.
// Набор можно заменить (Fluent 3D / кастом) — просто подменив файлы в assets/emoji.
const MAP: Record<string, string> = {
  '🧘': e1f9d8,
  '🫁': e1fac1,
  '🧭': e1f9ed,
  '🧠': e1f9e0,
  '🎉': e1f389,
  '🌱': e1f331,
  '🍎': e1f34e,
  '🌙': e1f319,
};

export function Emoji({ e, className }: { e: string; className?: string }) {
  const src = MAP[e];
  if (!src) return <span className={className}>{e}</span>;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={className}
      style={{ display: 'inline-block', objectFit: 'contain', verticalAlign: 'middle' }}
    />
  );
}
